export default "__VITE_ASSET__4b4eab5a__"